import Vue from 'vue'

const validArr = {}
let validIndex = 0

function regRule (ele, t, rule = [], value) {
  let flag = true
  let result = null
  for (let i in rule) {
    result = rule[i].rule.test(value)
    if (rule[i].flag) {
      result = !result
    }
    if (result) {
      ele.style.display = 'block'
      t.nodeValue = rule[i].tips
      flag = false
      break
    } else {
      ele.style.display = 'none'
    }
  }
  return flag
}

Vue.directive('check', {
  bind: function (el, binding) {
    let ele = document.createElement('P')
    let t = document.createTextNode('')
    let valid = {
      id: validIndex,
      el: el,
      ele: ele,
      t: t,
      rules: binding.value
    }
    validArr[validIndex++] = valid
    ele.appendChild(t)
    ele.style.color = '#EC007E'
    el.valid = valid
  },
  inserted: function (el, binding) {
    el.parentNode.appendChild(el.valid.ele)
    el.oninput = function () {
      regRule(el.valid.ele, el.valid.t, binding.value, el.value)
    }
  },
  unbind: function (el, binding) {
    for (let key in validArr) {
      if (validArr[key].id === el.valid.id) {
        delete validArr[key]
      }
    }
  }
})

const formValid = function () {
  let flag = true
  for (let i in validArr) {
    flag = regRule(validArr[i].ele, validArr[i].t, validArr[i].rules, validArr[i].el.value) && flag
  }
  return flag
}
export default formValid


// WEBPACK FOOTER //
// ./src/directive/formValid.js